import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import WebsocketUpdates from './WebsocketUpdates';
import extractText from 'flarum/common/utils/extractText';
import RealtimeState from '../../RealtimeState';
export default function () {
  extend(IndexPage.prototype, 'oninit', function () {
    this._realtimeWebsocketUpdates = new WebsocketUpdates();
    this._realtimeReleaseTimeout = this._realtimeWebsocketUpdates.getReleaseInterval();
    this._realtimeWebsocketEventPosted = data => {
      var _params$filter;
      const params = app.discussions.getParams();
      const activeTag = params.tags ? app.store.getBy('tags', 'slug', params.tags) : null;
      const noFilters = Object.keys((_params$filter = params.filter) != null ? _params$filter : {}).length === 0;
      if (!params.q && !params.sort && (activeTag || noFilters)) {
        var _recipientUsers, _ref, _recipientGroups, _ref2, _recipientUsers2, _ref3, _recipientGroups2, _ref4, _tags, _ref5, _tags2, _ref6, _subscription, _ref7, _tags3, _ref8, _discussions$getPages, _app$current$get, _subscription3, _ref0;
        const entity = app.store.pushPayload(data);
        let discussion = entity instanceof Discussion ? entity : null;
        if (!discussion && entity instanceof Post) {
          discussion = entity.discussion();
        }
        if (!discussion) return;

        // Byobu private discussions guards.
        if (app.current.data.routeName === 'byobuPrivate' && !((_recipientUsers = (_ref = discussion).recipientUsers) != null && _recipientUsers.call(_ref) && (_recipientGroups = (_ref2 = discussion).recipientGroups) != null && _recipientGroups.call(_ref2))) {
          return;
        }
        if (app.current.data.routeName === 'byobuPrivate' && ((_recipientUsers2 = (_ref3 = discussion).recipientUsers) == null || (_recipientUsers2 = _recipientUsers2.call(_ref3)) == null ? void 0 : _recipientUsers2.length) === 0 && ((_recipientGroups2 = (_ref4 = discussion).recipientGroups) == null || (_recipientGroups2 = _recipientGroups2.call(_ref4)) == null ? void 0 : _recipientGroups2.length) === 0) {
          return;
        }
        if (app.current.data.routeName === 'byobuUserPrivate') return;
        if (app.current.data.routeName === 'user.discussions') return;

        // Tag-based filtering (flarum/tags).
        if (activeTag && (_tags = (_ref5 = discussion).tags) != null && _tags.call(_ref5)) {
          const tagIds = discussion.tags().map(tag => tag.id());
          if (!tagIds.includes(activeTag.id())) return;
        }
        if ((_tags2 = (_ref6 = discussion).tags) != null && _tags2.call(_ref6) && discussion.tags().find(tag => {
          var _tag$isHidden, _tag$subscription;
          if (activeTag && activeTag.id() === tag.id()) return false;
          if (!activeTag && (_tag$isHidden = tag.isHidden) != null && _tag$isHidden.call(tag)) return true;
          return ((_tag$subscription = tag.subscription) == null ? void 0 : _tag$subscription.call(tag)) === 'hide';
        })) {
          return;
        }

        // Subscription filtering (flarum/subscriptions).
        if (((_subscription = (_ref7 = discussion).subscription) == null ? void 0 : _subscription.call(_ref7)) === 'ignore') return;
        const subscribedTag = (_tags3 = (_ref8 = discussion).tags) == null || (_tags3 = _tags3.call(_ref8)) == null ? void 0 : _tags3.find(tag => {
          var _tag$subscription2, _tag$subscription3;
          return ((_tag$subscription2 = tag.subscription) == null ? void 0 : _tag$subscription2.call(tag)) === 'lurk' || ((_tag$subscription3 = tag.subscription) == null ? void 0 : _tag$subscription3.call(tag)) === 'follow';
        });
        if (app.current.get('routeName') === 'following') {
          var _params$filter2, _subscription2, _ref9;
          if ((_params$filter2 = params.filter) != null && _params$filter2['following-tag'] && !subscribedTag || ((_subscription2 = (_ref9 = discussion).subscription) == null ? void 0 : _subscription2.call(_ref9)) !== 'follow') {
            return;
          }
        }
        const websocketUpdates = this._realtimeWebsocketUpdates;
        if (websocketUpdates.has(discussion)) return;
        if (((_discussions$getPages = app.discussions.getPages()[0]) == null || (_discussions$getPages = _discussions$getPages.items[0]) == null ? void 0 : _discussions$getPages.id()) === discussion.id()) return;
        const pushOnIndex = !app.current.get('discussion');
        const pushOnView = discussion.id() === ((_app$current$get = app.current.get('discussion')) == null ? void 0 : _app$current$get.id()) || subscribedTag || ((_subscription3 = (_ref0 = discussion).subscription) == null ? void 0 : _subscription3.call(_ref0)) === 'follow';
        if (pushOnIndex || pushOnView) {
          websocketUpdates.push(discussion);
          app.setTitleCount(websocketUpdates.length());
          m.redraw();
        }
      }
    };
  });
  extend(IndexPage.prototype, 'oncreate', function () {
    // Bind handlers against the current channel objects. Extracted so it can
    // re-fire on reconnect — see flarum/framework#4597.
    const bindHandlers = () => {
      var _app$websocket_channe, _app$websocket_channe2, _app$websocket_channe3, _app$websocket_channe4;
      (_app$websocket_channe = app.websocket_channels.public) == null || _app$websocket_channe.bind('Flarum\\Discussion\\Event\\Started', this._realtimeWebsocketEventPosted.bind(this));
      (_app$websocket_channe2 = app.websocket_channels.public) == null || _app$websocket_channe2.bind('Flarum\\Post\\Event\\Posted', this._realtimeWebsocketEventPosted.bind(this));
      (_app$websocket_channe3 = app.websocket_channels.user) == null || _app$websocket_channe3.bind('Flarum\\Discussion\\Event\\Started', this._realtimeWebsocketEventPosted.bind(this));
      (_app$websocket_channe4 = app.websocket_channels.user) == null || _app$websocket_channe4.bind('Flarum\\Post\\Event\\Posted', this._realtimeWebsocketEventPosted.bind(this));
    };
    bindHandlers();
    this._realtimeReconnectDisposer = RealtimeState.onChannelsReconnected(bindHandlers);
  });
  extend(IndexPage.prototype, 'onremove', function () {
    var _this$_realtimeReconn, _app$websocket_channe5, _app$websocket_channe6, _app$websocket_channe7, _app$websocket_channe8;
    (_this$_realtimeReconn = this._realtimeReconnectDisposer) == null || _this$_realtimeReconn.call(this);
    this._realtimeReconnectDisposer = null;
    (_app$websocket_channe5 = app.websocket_channels.public) == null || _app$websocket_channe5.unbind('Flarum\\Discussion\\Event\\Started');
    (_app$websocket_channe6 = app.websocket_channels.public) == null || _app$websocket_channe6.unbind('Flarum\\Post\\Event\\Posted');
    (_app$websocket_channe7 = app.websocket_channels.user) == null || _app$websocket_channe7.unbind('Flarum\\Discussion\\Event\\Started');
    (_app$websocket_channe8 = app.websocket_channels.user) == null || _app$websocket_channe8.unbind('Flarum\\Post\\Event\\Posted');
  });
  extend(IndexPage.prototype, 'contentItems', function (items) {
    const websocketUpdates = this._realtimeWebsocketUpdates;
    if (!websocketUpdates || websocketUpdates.isEmpty()) return;
    const releaseUpdates = () => {
      websocketUpdates.release(app.discussions);
      app.setTitleCount(0);
      m.redraw();
    };
    const buttonLabel = releaseTimeout => websocketUpdates.autoRelease() ? app.translator.trans('flarum-realtime.forum.push.discussion-list-new-activity-with-auto-release', {
      count: websocketUpdates.length(),
      releaseTimeout
    }) : app.translator.trans('flarum-realtime.forum.push.discussion-list-new-activity', {
      count: websocketUpdates.length()
    });
    websocketUpdates.startTimer();
    websocketUpdates.onTimer(second => {
      if (second === 0) return releaseUpdates();
      this.$('.DiscussionList-update > .Button-label').text(extractText(buttonLabel(second)));
    });
    items.add('realtimeNewActivity', Button.component({
      className: 'Button DiscussionList-update',
      'aria-live': 'polite',
      'aria-atomic': 'true',
      onclick: releaseUpdates
    }, buttonLabel(this._realtimeReleaseTimeout)), 95);
  });
  extend(IndexPage.prototype, 'actionItems', items => {
    items.remove('refresh');
  });
}